import { RouterProvider } from "react-router";
import routePath from "./routers";
import { PopupProvider } from "./context/PopupProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { SiteProvider } from "./context/SiteProvider";
import { AuthProvider } from "./context/AuthProvider";

function App() {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <SiteProvider>
          <PopupProvider>
            <RouterProvider router={routePath} />
          </PopupProvider>
        </SiteProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
